import React from 'react';

import { SearchResult } from '../api/services/search/interfaces';

interface Props {
  result: SearchResult;
}

const Result: React.FC<Props> = ({ result }: Props) => (
  <a rel="noopener noreferrer" href={result.url} className={'col-md-12'}>
    <div className={'search-result'}>
      <span className={'headline font-weight-bold'}>{result.title}</span>
      <br />
      {result.summary && (
        <>
          <br />
          <span className="headline d-inline-block mb-1">{result.summary}</span>
          <br />
        </>
      )}
      <span className="breadcrumbs footnote mt-1 d-inline-block">
        {result.breadcrumb?.map((breadcrumb, index) => (
          <span className="breadcrumbs__item">
            {breadcrumb.title}
            {result.breadcrumb && index < result.breadcrumb.length - 1 && ' > '}
          </span>
        ))}
      </span>
    </div>
  </a>
);

export default Result;
